import { render, staticRenderFns } from "./VehicleCard.vue?vue&type=template&id=f249fc14&scoped=true&"
import script from "./VehicleCard.vue?vue&type=script&lang=js&"
export * from "./VehicleCard.vue?vue&type=script&lang=js&"
import style0 from "./VehicleCard.vue?vue&type=style&index=0&id=f249fc14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f249fc14",
  null
  
)

export default component.exports